/**
 * 접속 지역 정보를 반환합니다.
 * Intl.DateTimeFormat timezone 기반으로 지역을 추출합니다.
 * 예: "Asia/Seoul", "America/New_York"
 */
export const getRegion = (): string => {
  if (typeof window === 'undefined') return '';
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return '';
  }
};
